import { BaseEntity } from './baseEntity';
import { Person } from './organisation';

export enum NotificationState {
  UNSEEN = 'UNSEEN',
  SEEN = 'SEEN',
  OPENED = 'OPENED',
}

export interface Notification extends BaseEntity {
  recipient: Person;
  title: string;
  message: string;
  important: boolean;
  state: NotificationState;
  url: string;
}
